// toastBus.ts — tiny event emitter bridging non-React code (QueryClient
// MutationCache) into the React toast system. The StoreProvider subscribes
// to this bus and dispatches TOAST actions.

import type { Tone } from '@/domain/types';

type Listener = (msg: string, tone: Tone) => void;

class ToastBus {
  private listeners = new Set<Listener>();

  subscribe(fn: Listener) {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  }

  emit(msg: string, tone: Tone = 'error') {
    this.listeners.forEach((fn) => fn(msg, tone));
  }
}

export const toastBus = new ToastBus();
